<template>
  <div class="card-error">{{ errorMessage }}</div>
</template>

<script>
export default {
  name: 'CardError',
  props: [
    'errorMessage',
  ],
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';

  .card-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    color: $riseup_white;
    background: $riseup_coral;
    font-size: 16px;
    text-align: center;
    height: 74px;
    font-weight: bold;
    line-height: 19px;
  }
</style>
